import * as environment from '../../environments/environment';
export const reducers = {};
export const metaReducers = !environment.production ? [] : [];
//# sourceMappingURL=index.js.map